 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER101DIFFICULTTODISTINGUISHBETWEENFRIENDANDFOE from '@/components/0_chapter101difficulttodistinguishbetweenfriendandfoe'
 import A_CHAPTER102HEAVENLYTHUNDERANDEARTHFIRE from '@/components/1_chapter102heavenlythunderandearthfire'
 import A_CHAPTER103MINDYOUROWNBUSINESS from '@/components/2_chapter103mindyourownbusiness'
 import A_CHAPTER104MYSTERIOUSPAINTING from '@/components/3_chapter104mysteriouspainting'
 import A_CHAPTER105GOODBYELITTLEWEN from '@/components/4_chapter105goodbyelittlewen'
 import A_CHAPTER106SEEOFF from '@/components/5_chapter106seeoff'
 import A_CHAPTER107GREATMOTHER from '@/components/6_chapter107greatmother'
 import A_CHAPTER108LOVEANDHATE from '@/components/7_chapter108loveandhate'
 import A_CHAPTER109PASSINGBY from '@/components/8_chapter109passingby'
 import A_CHAPTER110SEEYOULATER from '@/components/9_chapter110seeyoulater'
 import A0_CHAPTER111UNRIVALEDGOODMAN from '@/components/10_chapter111unrivaledgoodman'
 import A1_CHAPTER112THEREVENGEOFKILLINGTHEMOTHER from '@/components/11_chapter112therevengeofkillingthemother'
 import A2_CHAPTER113REVENGE from '@/components/12_chapter113revenge'
 import A3_CHAPTER114ALARMEDUNCERTAINTY from '@/components/13_chapter114alarmeduncertainty'
 import A4_CHAPTER115TOAD from '@/components/14_chapter115toad'
 import A5_CHAPTER116LUSTTURTLE from '@/components/15_chapter116lustturtle'
 import A6_CHAPTER117SHOWBAZAAR from '@/components/16_chapter117showbazaar'
 import A7_CHAPTER118JIANGXUE from '@/components/17_chapter118jiangxue'
 import A8_CHAPTER119THREEWOMENFORAPLAY from '@/components/18_chapter119threewomenforaplay'
 import A9_CHAPTER120DIFFICULTTORETRACT from '@/components/19_chapter120difficulttoretract'
 import A0_CHAPTER121PASSION from '@/components/20_chapter121passion'
 import A1_CHAPTER122FIRSTAID from '@/components/21_chapter122firstaid'
 import A2_CHAPTER123POSSESSION from '@/components/22_chapter123possession'
 import A3_CHAPTER124FUNERAL from '@/components/23_chapter124funeral'
 import A4_CHAPTER125PAINANDHAPPINESS from '@/components/24_chapter125painandhappiness'
 import A5_CHAPTER126RESTAURANT from '@/components/25_chapter126restaurant'
 import A6_CHAPTER127FLYINRESTAURANT from '@/components/26_chapter127flyinrestaurant'
 import A7_CHAPTER128FIGHT from '@/components/27_chapter128fight'
 import A8_CHAPTER129ABDOMINALBACKENEMY from '@/components/28_chapter129abdominalbackenemy'
 import A9_CHAPTER130CHENWENAPPEARED from '@/components/29_chapter130chenwenappeared'
 import A0_CHAPTER131TRIPLEXSTATE from '@/components/30_chapter131triplexstate'
 import A1_CHAPTER132CHENWENSAWAKENING from '@/components/31_chapter132chenwensawakening'
 import A2_CHAPTER133COOLDOWNSKILLS from '@/components/32_chapter133cooldownskills'
 import A3_CHAPTER134ANCIENTCHINESEMEDICINE from '@/components/33_chapter134ancientchinesemedicine'
 import A4_CHAPTER135ECCENTRICPATIENT from '@/components/34_chapter135eccentricpatient'
 import A5_CHAPTER136EVIL from '@/components/35_chapter136evil'
 import A6_CHAPTER137LEFTANDRIGHT from '@/components/36_chapter137leftandright'
 import A7_CHAPTER138CHENWENFORHELP from '@/components/37_chapter138chenwenforhelp'
 import A8_CHAPTER139THEDIFFICULTIESOFCHENWEN from '@/components/38_chapter139thedifficultiesofchenwen'
 import A9_CHAPTER140CASINOVISIT from '@/components/39_chapter140casinovisit'
 import A0_CHAPTER141ALTERATIONOFXIAOWEN from '@/components/40_chapter141alterationofxiaowen'
 import A1_CHAPTER142THESMELLOFCONSPIRACY from '@/components/41_chapter142thesmellofconspiracy'
 import A2_CHAPTER143SCAPEGOAT from '@/components/42_chapter143scapegoat'
 import A3_CHAPTER144POISON from '@/components/43_chapter144poison'
 import A4_CHAPTER145ETHELSDISEASE from '@/components/44_chapter145ethelsdisease'
 import A5_CHAPTER146INFECTIOUSDISEASE from '@/components/45_chapter146infectiousdisease'
 import A6_CHAPTER147IRAQBATTLEFIELD from '@/components/46_chapter147iraqbattlefield'
 import A7_CHAPTER148LOVERIVAL from '@/components/47_chapter148loverival'
 import A8_CHAPTER149WUQIAN from '@/components/48_chapter149wuqian'
 import A9_CHAPTER150PHARMACEUTICALCOMPANY from '@/components/49_chapter150pharmaceuticalcompany'
 import A0_CHAPTER151UNINVITEDGUEST from '@/components/50_chapter151uninvitedguest'
 import A1_CHAPTER152COMBAT from '@/components/51_chapter152combat'
 import A2_CHAPTER153DEBILITATINGFORCE from '@/components/52_chapter153debilitatingforce'
 import A3_CHAPTER154OLDPLACE from '@/components/53_chapter154oldplace'
 import A4_CHAPTER155EXTRAMARITALLOVE from '@/components/54_chapter155extramaritallove'
 import A5_CHAPTER156UNDEAD from '@/components/55_chapter156undead'
 import A6_CHAPTER157MUTUALHARM from '@/components/56_chapter157mutualharm'
 import A7_CHAPTER158OLDEVENTS from '@/components/57_chapter158oldevents'
 import A8_CHAPTER159CHARITY from '@/components/58_chapter159charity'
 import A9_CHAPTER160EVERYONEHASTHEIROWNASPIRATIONS from '@/components/59_chapter160everyonehastheirownaspirations'
 import A0_CHAPTER161CREATIONOFOPPORTUNITIES from '@/components/60_chapter161creationofopportunities'
 import A1_CHAPTER162SCIENTIFICCONTRAST from '@/components/61_chapter162scientificcontrast'
 import A2_CHAPTER163IMPERSONATION from '@/components/62_chapter163impersonation'
 import A3_CHAPTER164SUBSCRIPT from '@/components/63_chapter164subscript'
 import A4_CHAPTER165THETRUTH from '@/components/64_chapter165thetruth'
 import A5_CHAPTER166FIRSTREADINGSECRETBOOK from '@/components/65_chapter166firstreadingsecretbook'
 import A6_CHAPTER167JADE from '@/components/66_chapter167jade'
 import A7_CHAPTER168VINEGAR from '@/components/67_chapter168vinegar'
 import A8_CHAPTER169BUYACAR from '@/components/68_chapter169buyacar'
 import A9_CHAPTER170LILYBLOOMING from '@/components/69_chapter170lilyblooming'
 import A0_CHAPTER171STRANGEDREAMS from '@/components/70_chapter171strangedreams'
 import A1_CHAPTER172STRANGEPATIENT from '@/components/71_chapter172strangepatient'
 import A2_CHAPTER173MYSTERIOUSMASTER from '@/components/72_chapter173mysteriousmaster'
 import A3_CHAPTER174WUYU from '@/components/73_chapter174wuyu'
 import A4_CHAPTER175SELLINGHOUSE from '@/components/74_chapter175sellinghouse'
 import A5_CHAPTER176CLEARSKYTHUNDERBOLT from '@/components/75_chapter176clearskythunderbolt'
 import A6_CHAPTER177BIGDAYS from '@/components/76_chapter177bigdays'
 import A7_CHAPTER178HELLOELDERBROTHERANDELDERSISTERINLAW from '@/components/77_chapter178helloelderbrotherandeldersisterinlaw'
 import A8_CHAPTER179TWOTHINGSTOSAY from '@/components/78_chapter179twothingstosay'
 import A9_CHAPTER180THEWOUNDEDLIDESHENG from '@/components/79_chapter180thewoundedlidesheng'
 import A0_CHAPTER181BREAKANARMWITHOUTAWORD from '@/components/80_chapter181breakanarmwithoutaword'
 import A1_CHAPTER182LEGENDOFTHEJADEGANG from '@/components/81_chapter182legendofthejadegang'
 import A2_CHAPTER183THETRUTHABOUTWUYU from '@/components/82_chapter183thetruthaboutwuyu'
 import A3_CHAPTER184EXPANDSITE from '@/components/83_chapter184expandsite'
 import A4_CHAPTER185ROYALNO1 from '@/components/84_chapter185royalno1'
 import A5_CHAPTER186ACOMPLETEVICTORY from '@/components/85_chapter186acompletevictory'
 import A6_CHAPTER187GREATSLEEP from '@/components/86_chapter187greatsleep'
 import A7_CHAPTER188GREENRINGCOMPANY from '@/components/87_chapter188greenringcompany'
 import A8_CHAPTER189SPACERMIGRATION from '@/components/88_chapter189spacermigration'
 import A9_CHAPTER190LONGROAD from '@/components/89_chapter190longroad'
 import A0_CHAPTER191ENTANGLEMENT from '@/components/90_chapter191entanglement'
 import A1_CHAPTER192IFONEROOMWASNOTSWEPTHOWCOULDONESWEEPTHEWORLD from '@/components/91_chapter192ifoneroomwasnotswepthowcouldonesweeptheworld'
 import A2_CHAPTER193LIULEI from '@/components/92_chapter193liulei'
 import A3_CHAPTER194LOOKINGFORTROUBLE from '@/components/93_chapter194lookingfortrouble'
 import A4_CHAPTER195HEROSAVEBEAUTY from '@/components/94_chapter195herosavebeauty'
 import A5_CHAPTER196WITCHCRAFT from '@/components/95_chapter196witchcraft'
 import A6_CHAPTER197ASYOUWISH from '@/components/96_chapter197asyouwish'
 import A7_CHAPTER198STRANGEDISORDER from '@/components/97_chapter198strangedisorder'
 import A8_CHAPTER199FARAWAYHOME from '@/components/98_chapter199farawayhome'
 import A9_CHAPTER200SURVEY from '@/components/99_chapter200survey'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter101difficulttodistinguishbetweenfriendandfoe",
 			"name" : "0_chapter101difficulttodistinguishbetweenfriendandfoe",
 			"component" : A_CHAPTER101DIFFICULTTODISTINGUISHBETWEENFRIENDANDFOE
 		},
 		{
 			"path" : "/1_chapter102heavenlythunderandearthfire",
 			"name" : "1_chapter102heavenlythunderandearthfire",
 			"component" : A_CHAPTER102HEAVENLYTHUNDERANDEARTHFIRE
 		},
 		{
 			"path" : "/2_chapter103mindyourownbusiness",
 			"name" : "2_chapter103mindyourownbusiness",
 			"component" : A_CHAPTER103MINDYOUROWNBUSINESS
 		},
 		{
 			"path" : "/3_chapter104mysteriouspainting",
 			"name" : "3_chapter104mysteriouspainting",
 			"component" : A_CHAPTER104MYSTERIOUSPAINTING
 		},
 		{
 			"path" : "/4_chapter105goodbyelittlewen",
 			"name" : "4_chapter105goodbyelittlewen",
 			"component" : A_CHAPTER105GOODBYELITTLEWEN
 		},
 		{
 			"path" : "/5_chapter106seeoff",
 			"name" : "5_chapter106seeoff",
 			"component" : A_CHAPTER106SEEOFF
 		},
 		{
 			"path" : "/6_chapter107greatmother",
 			"name" : "6_chapter107greatmother",
 			"component" : A_CHAPTER107GREATMOTHER
 		},
 		{
 			"path" : "/7_chapter108loveandhate",
 			"name" : "7_chapter108loveandhate",
 			"component" : A_CHAPTER108LOVEANDHATE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js